export default {
  path: '/pay-psw',
  meta: {
    title: '修改支付密码',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/pay-psw`),
}



// WEBPACK FOOTER //
// ./src/views/PayPassword/router.js